import { freddyTheme as theme } from '@coolblue-development/freddy';
export const getDefaultSelectableBoxStyles = (numberOfProducts) => ({
    gridColumn: 'span 12',
    gap: 0,
    gridTemplateRows: 'subgrid',
    gridRow: 'span 4',
    ...(numberOfProducts === 1 && {
        [theme.breakpoint.minWidth('md')]: {
            gridColumn: 'span 6',
            gridRowEnd: 'span 4',
        },
    }),
    [theme.breakpoint.minWidth('lg')]: {
        gridColumn: 'span 4',
        gridRowEnd: 'span 4',
    },
});
//# sourceMappingURL=InsuranceDefaultSelectableBox.styles.js.map